(ns dre.panels.events
  (:require
    [day8.re-frame.tracing :refer-macros [fn-traced]]
    [dre.panels.db :as panels]
    [re-frame.core :as rf]))


(def db-path :panels)


;; -- Events

(rf/reg-event-fx
  ::set-panel
  [(rf/path db-path) rf/trim-v]
  (fn-traced
    [{db :db} [panel-id init-data]]
    {:pre [(contains? panels/index panel-id)]}
    (let [{:keys [init-db init-fx]} (get panels/index panel-id)]
      {:db (-> db
               (assoc :current panel-id)
               (update-in [:data panel-id] (partial merge init-db)))
       :fx [(when init-fx
              [:dispatch [init-fx init-data]])]})))


(rf/reg-event-db
  ::clear
  [(rf/path db-path) rf/trim-v]
  (fn-traced
    [db]
    (dissoc db :current)))


;; -- Subscriptions

(rf/reg-sub
  ::state
  (fn [db _]
    (db-path db)))


(rf/reg-sub
  ::current-panel-id
  :<- [::state]
  (fn [db _]
    (:current db)))


(rf/reg-sub
  ::current-panel-data
  :<- [::state]
  (fn [db _]
    (get-in db [:data (:current db)])))
